export default {
    translations: {
        mainPage: {
            languageLbl: 'Izaberite jezik',
            titleLbl: 'Dobrodošli u Bunge MyAccess!',
            subtitleLbl: 'Šta želite da uradite?',
            activateAccountLbl: 'Aktiviraj nalog',
            accountRecoveryLbl: 'Zaboravili ste lozinku?',
            changeEmailLbl: 'Promeni e-mail adresu'
        },
        activateAccount: {
            titleLbl: 'Aktivacija naloga',
            residenceCountry: {
                titleLbl: 'Hajde da dobijemo malo informacija o vama da biste započeli. Još samo nekoliko klikova!',
                selectCountryLbl: 'Koja je vaša zemlja prebivališta?'
            },
            legalPolicy: {
                titleLbl: 'Saglasnost sa pravnim uslovima',
                confirmLbl: 'Potvrđujem da sam pročitao/la, razumeo/la i saglasan/na sam sa gore navedenim uslovima'
            },
            provideKey: {
                titleLbl: 'Unesite registracioni ključ',
                enrolmentKeyLbl: 'Koristite jedinstveni ključ za registraciju koji vam je dala služba ljudskih resursa. Molimo vas da ne delite ključ ni sa kim drugim.'
            },
            confirmData: {
                titleLbl: 'Potrebno je još nekoliko detalja i sve je spremno!',
                disclaimerLbl: 'Bunge će koristiti vašu ličnu e-mail adresu isključivo za samostalni pristup Bunge aplikacijama i resetovanje lozinke. Bunge nikada neće koristiti ove informacije za bilo koju drugu vrstu komunikacije.',
                confirmLbl: 'Potvrđujem da su gore navedeni podaci o nalogu tačni',
                subscriptionLbl: 'Želim pristup aplikaciji Bunge GoConnect kako bih primao/la vesti, biltene i obaveštenja o kompaniji Bunge i svom radnom okruženju',
                form: {
                    firstName: 'Ime',
                    lastName: 'Prezime',
                    hireDate: 'Datum zaposlenja',
                    personExternalId: 'Bunge zaposleni ID',
                    emailAddress: 'E-mail adresa',
                    password: 'Lozinka',
                    passwordConfirm: 'Potvrdite lozinku',
                    emailConfirm: 'Potvrdite e-mail adresu'
                },
                confirmation: {
                    title: 'Aktivacija naloga',
                    text: 'Vaš nalog je sada aktiviran. Molimo sačekajte.'
                },
                check: {
                    passw: 'Lozinke se ne podudaraju',
                    email: 'E-mail adrese se ne podudaraju'
                },
                dialog: {
                    title: 'Potvrdite aktivaciju naloga',
                    subtitle: 'Vaš nalog će sada biti aktiviran.',
                    firstName: 'Ime',
                    lastName: 'Prezime',
                    hireDate: 'Datum zaposlenja',
                    personExternalId: 'Bunge zaposleni ID',
                    email: 'E-mail',
                    question: 'Da li ste sigurni da želite da nastavite?'
                }
            },
            securityQuestion: {
                titleLbl: 'Podesite sigurnosno pitanje i odgovor'
            },
            activationConfirm: {
                activatedLbl: 'Nalog je aktiviran!',
                titleLbl: 'Odlično, sve je spremno!',
                confirmEmailLbl: 'Poslali smo vam imejl potvrdu sa svim potrebnim informacijama na vašu imejl adresu {value}.',
                linkLbl: 'Naći ćete linkove do Bunge aplikacija',
                thankYouLbl: 'Hvala vam!'
            }
        },
        recoveryCredentials: {
            provideEmail: {
                contentLbl: 'Unesite e-mail adresu koju ste koristili prilikom registracije'
            },
            validateCode: {
                titleLbl: 'Proverite jednokratni kod za potvrdu poslat na vašu e-mail adresu. Napomena: Ovaj kod važi samo 5 minuta.',
                contentLbl: 'Unesite isti kod za potvrdu ispod'
            },
            validView: {
                titleLbl: 'Šta želite da uradite?',
                loginBtn: 'Preuzmi korisničko ime',
                passwordBtn: 'Resetuj lozinku'
            },
            loginView: {
                contentLbl: 'Vaše korisničko ime je:'
            },
            passwordView: {
                headerLbl: 'Unesite novu lozinku',
                sendRequestBtn: 'Potvrdite novu lozinku',
                successPasswordLbl: 'Lozinka naloga je uspešno promenjena.',
                redirectLbl: 'Za nekoliko sekundi bićete preusmereni na eksternu stranicu.',
                redirectBtn: 'Preusmeri'
            }
        },
        common: {
            continueBtn: 'Nastavi',
            backBtn: 'Nazad',
            cancelBtn: 'Otkaži',
            downloadBtn: 'Preuzmi',
            returnBtn: 'Vrati se na glavnu stranicu',
            confirmBtn: 'Potvrdi',
            closeBtn: 'Zatvori'
        },
        validation: {
            required: 'Ovo polje je obavezno',
            email: 'Unesite važeću e-mail adresu',
            password: 'Unesite važeću lozinku (1 specijalni znak: !@#$%^&*+=, 1 veliko slovo, 1 cifra, 8 do 25 znakova)'
        },
        apiErrors: {
            UNKNOWN_ERROR: 'Došlo je do nepoznate greške',
            INVALID_ENROLLMENT_KEY_ERROR: 'Unet je nevažeći registracioni ključ',
            ACCOUNT_NOT_FOUND_ERROR: 'Nalog nije pronađen',
            ACCOUNT_INACTIVE_ERROR: 'Nalog nije aktivan',
            ACCOUNT_ALREADY_ACTIVATED_ERROR: 'Nalog je već aktiviran',
            INVALID_EMAIL_FORMAT_ERROR: 'Nevažeći format e-mail adrese',
            INVALID_EMAIL_ERROR: 'Unesite drugu e-mail adresu',
            INVALID_PASSWORD_FORMAT_ERROR: 'Nevažeći format lozinke (1 specijalni znak: !@#$%^&*+=, 1 veliko slovo, 1 cifra, 8 do 25 znakova)',
            INVALID_VALIDATION_CODE: 'Ups! Kod nije važeći. Pokušajte ponovo.',
            VALIDATION_CODE_EXPIRED: 'Kod za potvrdu je istekao. Generišite novi kod.',
            INVALID_RECOVERY_TOKEN: 'Sesija za resetovanje lozinke je istekla. Molimo pokušajte ponovo.',
            MAX_ATTEMPTS: 'Prekoračili ste maksimalan broj pokušaja. Molimo pokušajte ponovo.'
        },
        versioning: {
            title: 'Evidencija promena verzije',
            version: 'Verzija',
            description: 'Opis promena'
        },
        idle: {
            title: 'Sesija je istekla',
            info1: 'Sesija je istekla zbog dugog perioda neaktivnosti.',
            info2: 'Aplikacija će se ponovo učitati za {value} sekundi',
            reload: 'Ponovo učitaj'
        }
    }
}